// Used to promisify the response of the API call
// Returns a promise
type CallbackBasedFn<T = (...args: any[]) => void> = T extends (
	...args: infer TArgs
) => void
	? (...args: TArgs) => void
	: never;

export function promisifyResponse<TResponse = any>(
	callbackBasedFn: CallbackBasedFn
) {
	return function promisified(...args: Parameters<typeof callbackBasedFn>) {
		return new Promise<TResponse>((resolve, reject) => {
			callbackBasedFn(
				...args,
				(response: TResponse, success: boolean) => {
					if (success) return resolve(response);

					return reject(response);
				}
			);
		});
	};
}
